export default {
    quotaExceededTitle: 'Plan limit reached',
    quotaExceededMessage: 'You have reached your plan limit for this resource.',
    quotaHardCapMessage: 'An infrastructure limit was reached for this resource. It cannot be extended via upgrade or add-ons.',
    quotaCtaUpgrade: 'Do you want to go to My subscription to request a plan upgrade?',
    quotaCtaUpgradeOrAddon: 'Do you want to go to My subscription to request an upgrade or contract an add-on?',
    quotaTitle: 'Quotas and usage',
    quotaMenu: 'Quotas',
    quotaSubtitle: 'Check a tenant usage against its effective limits',
    selectTenant: 'Select a tenant',
    quotaTenant: 'Tenant',
    cyclePeriod: 'Cycle period',
    cycleRange: 'Validity',
    colModule: 'Module',
    colAttribute: 'Attribute',
    colCurrent: 'Usage',
    colPlanLimit: 'Plan limit',
    colAddonBonus: 'Add-ons',
    colEffective: 'Effective limit',
    colUsage: 'Usage',
    nearLimit: 'Near limit',
    atLimit: 'Limit reached',
    perParentLimit: 'Per-parent limit',
    exceeded: 'Exceeded',
    resetQuota: 'Reset usage',
    confirmReset: 'Reset this tenant usage for the current cycle?',
    resetSuccess: 'Usage reset successfully',
    resetError: 'Error resetting the usage',
    quotaLoadError: 'Error loading the tenant usage',
    noUsageSelected: 'Select a tenant to see its usage',
    noUsageData: 'There is no usage data for this tenant',
    query: 'Query',
};
